export const commonConstants = {
    GET_EMAIL_SIGN_DATA_LOADING: "GET_EMAIL_SIGN_DATA_LOADING",
    GET_EMAIL_SIGN_DATA_SUCCESS:"GET_EMAIL_SIGN_DATA_SUCCESS",
    GET_EMAIL_SIGN_DATA_ERROR:"GET_EMAIL_SIGN_DATA_ERROR",

    CALL_INIDIVIDUAL_API: "CALL_INIDIVIDUAL_API"
  };
